import { useAccessState } from 'modules/common';
import { StyledTextField } from 'modules/components/layer01';
import {
  SelectInstallationAreaField,
  SelectTaskAssigneeField,
  SelectTaskCategoryField,
  UploadAttachmentsField
} from 'modules/components/layer04';
import { AttachmentCard } from 'modules/components/layer05';
import { FormBaseLayout } from 'modules/components/layer10';
import React from 'react';
import * as ds from './dataService';
import {
  Stack,
  Typography
} from '@mui/material';
import { DateTime } from 'luxon';

import { SaveTask_Input } from 'generated/graphql';



export type SaveTaskFormProps = {
  id?: string;
  projectId?: string;
  handleCancel: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveTaskFormProps) => {
  const form = ds.useFormState(props.id ?? '');
  const [
    fnSaveTask,
    { loading }
  ] = ds.useSaveTask();
  const access = useAccessState('Task');

  const removeAttachment = (id: string) => {
    form.dispatch({
      type: 'REMOVE_FROM_ARRAY',
      payload: {
        key: 'attachments',
        value: id,
        identifier: 'id'
      }
    });
  };
  return (

    <FormBaseLayout.FC
      title='Save Task'
      subtitle='Easily assign tasks by filling in required information below'
      handleCancel={() => props.handleCancel()}
      handleSubmit={async () => {
        const tempFormState: SaveTask_Input = {
          id: form.formState.id !== '' ? form.formState.id : undefined,
          apiFileIds: form.formState.attachments.map((node) => node.id) ?? undefined,
          areaId: form.formState.areaId !== '' ? form.formState.areaId : undefined,
          assigneePersonId: form.formState.assignedPersonId !== '' ? form.formState.assignedPersonId : undefined,
          description: form.formState.taskDescription ?? undefined,
          dueDate: DateTime.fromFormat(form.formState.dueDate, 'yyyy-LL-dd') ?? null,
          name: form.formState.title ?? '',
          projectId: props.projectId ?? '',
          // statusId: form.formState ?? '',
          taskCategoryId: form.formState.categoryId !== '' ? form.formState.categoryId : null
        };

        await fnSaveTask({
          ...tempFormState
        });
        props.handleCancel();
      }}
      isLoading={loading}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <Stack

        rowGap='1.5rem'
        alignContent='space-between'
      >
        {/* <Box> */}
        <StyledTextField.FC
          {...form.genFieldProps('title')}
        />
        <Stack
          direction='row'
          columnGap='1rem'
        >
          <SelectTaskCategoryField.FC
            form={form}
            fieldName='categoryId'
          />
          <SelectInstallationAreaField.FC
            form={form}
            disabled={!access.create}
            fieldName='areaId'
          />
        </Stack>
        <Stack
          direction='row'
          columnGap='1rem'
        >
          <SelectTaskAssigneeField.FC
            form={form}
            fieldName='assignedPersonId'
          />
          <StyledTextField.FC
            {...form.genFieldProps('dueDate')}
            disabled={!access.create}
          />
        </Stack>
        <StyledTextField.FC
          {...form.genFieldProps('taskDescription')}
          multiline
          minRows={4}
          disabled={!access.create}
        />
        <Stack
          rowGap='1rem'
        >
          <Typography
            variant='formLabel'
          >
            Files
          </Typography>

          <UploadAttachmentsField.FC
            form={form}
            fieldName='attachments'
          />

        </Stack>


        {form.formState.attachments.map((node) => (
          <AttachmentCard.FC
            key={node.id}
            fileName={node.fileName ?? ''}
            url={node.url}
            formattedFileSize={node.formattedFileSize ?? ''}
            handleDelete={() => {
              removeAttachment(node.id ?? '');
            }}
            id={node.id ?? ''}
          />
        ))}
      </Stack>
    </FormBaseLayout.FC>
  );
};
